export default "<tabbed-modal-tab tab=\"$ctrl.tab\">\r\n\t<reports-tab export-log=\"$ctrl.exportLog\"></reports-tab>\r\n</tabbed-modal-tab>\r\n";